import type { Product } from "@models/product";
import type { ShoppingCartItem } from "@models/shoppingCart";

/**
 * How many pieces one unit of a cart line holds, from the product read (B-03): the line's own
 * variant's figure on a variant line, else the product's. Undefined when it isn't known — no
 * read, or a variant the read doesn't list or that carries no figure — and never the base
 * product's figure beside a variant's price (the rule ProductDetail keeps).
 *
 * Only the count comes from the product. The piece PRICE is the line's own price divided by it
 * (CartItemRow), never the read's `pricePerPiece`, which the API prices at the lowest vendor.
 */
export const linePiecesPerUnit = (
    item: Pick<ShoppingCartItem, "variant">,
    product: Pick<Product, "piecesPerUnit" | "variants"> | undefined,
): number | undefined => {
    if (!product) return undefined;
    if (!item.variant) return product.piecesPerUnit;

    const variantId = item.variant.variantId;
    // `?? []`: useCartProducts takes any object as a product, so a payload with no
    // variants list reaches here (PR 356 review) — the line then has no piece pricing.
    return (product.variants ?? []).find((v) => v.id === variantId)
        ?.piecesPerUnit;
};
